import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { OrderTracking, OrderTrackingPayload } from "@core/types";
import { ordersClient } from "@core/clients";

type GetOrderTracking = {
  options?: UseQueryOptions<OrderTracking | null, any, OrderTracking | null, any>;
  orderTrackingPayload: OrderTrackingPayload;
};

const useGetOrderTracking = ({ orderTrackingPayload, options }: GetOrderTracking) => {
  return useQuery<OrderTracking | null, any, OrderTracking | null, any>(
    ["order-tracking", orderTrackingPayload.orderId],
    async () => ordersClient.getOrderTracking(orderTrackingPayload),
    { ...options },
  );
};

export default useGetOrderTracking;
